__turbopack_context__.v({
  "donate_icon": "Lf9vAq_donate_icon",
  "donate_illustration": "Lf9vAq_donate_illustration",
  "donate_link": "Lf9vAq_donate_link",
  "donate_menu": "Lf9vAq_donate_menu",
  "donate_menu_inner": "Lf9vAq_donate_menu_inner",
  "donate_menu_intro": "Lf9vAq_donate_menu_intro",
  "donate_menu_item": "Lf9vAq_donate_menu_item",
});
